export function shouldShowViewCount(
  enabled: boolean,
  viewCount: number,
  viewCountThreshold: number
) {
  return enabled && viewCount >= viewCountThreshold;
}
